/*
  File: italiansecret-order-grid.js
  Description:
  Build Your Box order grid logic.
  - UberEats-like tabs navigation:
    - Tabs scroll horizontally (CSS), click scrolls to section (anchors)
    - Active tab updates automatically based on scroll position (IntersectionObserver)
  - Tabs are dynamic (reads buttons data-mode from DOM)
    Core: pizzas / gf / toppings / bases
    Extra: type--<handle> (auto from product_type, controlled via liquid blocks ordering too)
  - Pizzas: variant by SKU suffix (01 = Regular, 02 = Gluten Free)
  - Qty controls per card (Add → [-] n [+])
  - AJAX cart updates via /cart/update.js
  - Modal preview on image/title click with media slider
*/

(function () {
  function $(selector, root) {
    return (root || document).querySelector(selector);
  }

  function $$(selector, root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll(selector)
    );
  }

  function fetchCart() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart fetch failed');
      return res.json();
    });
  }

  function updateVariantQty(variantId, qty) {
    var payload = { updates: {} };
    payload.updates[variantId] = qty;

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart update failed');
      return res.json();
    });
  }

  function getQtyInCart(cart, variantId) {
    var idNum = Number(variantId);
    if (!isFinite(idNum)) return 0;
    var q = 0;
    (cart.items || []).forEach(function (item) {
      if (item.variant_id === idNum) q += item.quantity;
    });
    return q;
  }

  function formatMoney(cents) {
    var intCents = parseInt(cents, 10);
    if (!isFinite(intCents)) return '';
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(intCents);
    }
    return '£' + (intCents / 100).toFixed(2);
  }

  function getFixedHeaderOffset() {
    // Best-effort offset for sticky headers; safe default.
    // If your theme has a known header height, you can hardcode it here.
    var header = document.querySelector('[data-header], .header, header');
    if (!header) return 12;
    var rect = header.getBoundingClientRect();
    var h = rect && rect.height ? rect.height : 0;
    return Math.round(h) + 12;
  }

  function scrollToSection(sectionEl) {
    if (!sectionEl) return;
    var offset = getFixedHeaderOffset();

    var top =
      window.pageYOffset +
      sectionEl.getBoundingClientRect().top -
      offset;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth'
    });
  }

  function initOrderGrid(root) {
    if (!root) return;

    var defaultTab = root.getAttribute('data-default-tab') || 'pizzas';
    var showTabs = root.getAttribute('data-show-tabs') === 'true';
    var qtyStep = parseInt(root.getAttribute('data-qty-step'), 10);
    if (!isFinite(qtyStep) || qtyStep < 1) qtyStep = 1;

    var tabsWrap = $('[data-is-order-tabs]', root);
    var tabs = $$('.js-order-tab', root);
    var cards = $$('.is-order-card', root);
    var sections = $$('[data-order-section]', root);

    // If tabs are enabled but default tab doesn't exist, fallback to first available
    var availableModes = tabs
      .map(function (b) { return b.getAttribute('data-mode') || ''; })
      .filter(Boolean);

    var currentMode = defaultTab;
    if (showTabs && availableModes.length) {
      if (availableModes.indexOf(currentMode) === -1) currentMode = availableModes[0];
    }

    var busy = false;

    function setActiveTab(mode) {
      if (!showTabs) return;
      currentMode = mode;

      tabs.forEach(function (btn) {
        var m = btn.getAttribute('data-mode');
        if (m === mode) btn.classList.add('is-active');
        else btn.classList.remove('is-active');
      });

      // Ensure active tab is visible inside horizontal scroll container
    var active = tabs.find(function (b) {
    return b.classList.contains('is-active');
  });

  if (active && tabsWrap) {
    var left = active.offsetLeft;
    tabsWrap.scrollTo({
      left: Math.max(0, left - 8),
      behavior: 'smooth'
    });
  }
    }

    function computeActiveVariantId(card) {
      var isPizza = card.getAttribute('data-is-pizza') === 'true';
      var cardMode = card.getAttribute('data-card-mode') || '';

      if (isPizza) {
        if (cardMode === 'gf') {
          return card.getAttribute('data-gf-variant-id') || null;
        }
        // default pizza card mode (pizzas): prefer regular
        return (
          card.getAttribute('data-regular-variant-id') ||
          card.getAttribute('data-gf-variant-id') ||
          null
        );
      }

      // Non-pizza (topping/base/other types)
      return card.getAttribute('data-single-variant-id') || null;
    }

    function refreshCardTitle(card) {
      var titleSpan = $('.is-order-card__title-text', card);
      if (!titleSpan) return;

      var baseTitle = card.getAttribute('data-base-title') || '';
      var isPizza = card.getAttribute('data-is-pizza') === 'true';
      var cardMode = card.getAttribute('data-card-mode') || '';

      if (isPizza && cardMode === 'gf') {
        titleSpan.textContent = baseTitle + ' GF';
      } else {
        titleSpan.textContent = baseTitle;
      }
    }

    function refreshCardPrice(card) {
      var priceEl = $('.js-order-price', card);
      if (!priceEl) return;

      var b2bPriceText = card.getAttribute('data-b2b-price-text');
      if (b2bPriceText) {
        priceEl.textContent = b2bPriceText;
        return;
      }

      var isPizza = card.getAttribute('data-is-pizza') === 'true';
      var cardMode = card.getAttribute('data-card-mode') || '';
      var cents = null;

      if (isPizza) {
        if (cardMode === 'gf') {
          if (card.getAttribute('data-gf-price')) {
            cents = parseInt(card.getAttribute('data-gf-price'), 10);
          }
        } else {
          if (card.getAttribute('data-regular-price')) {
            cents = parseInt(card.getAttribute('data-regular-price'), 10);
          } else if (card.getAttribute('data-gf-price')) {
            cents = parseInt(card.getAttribute('data-gf-price'), 10);
          }
        }
      } else {
        if (card.getAttribute('data-single-price')) {
          cents = parseInt(card.getAttribute('data-single-price'), 10);
        }
      }

      if (!isFinite(cents)) {
        priceEl.textContent = '';
        return;
      }

      priceEl.textContent = formatMoney(cents);
    }

    function refreshCards() {
      // No filtering/hiding. Only compute active variant + title/price.
      cards.forEach(function (card) {
        var activeVariantId = computeActiveVariantId(card);
        if (activeVariantId) {
          card.setAttribute('data-active-variant-id', activeVariantId);
        } else {
          card.setAttribute('data-active-variant-id', '');
        }

        refreshCardTitle(card);
        refreshCardPrice(card);
      });
    }

    function setCardUIFromQty(card, qty) {
      var addBtn = $('.js-order-add-to-cart', card);
      var qtyBox = $('.is-order-card__qty', card);
      var qtyVal = $('.is-order-card__qty-value', card);

      if (!addBtn || !qtyBox || !qtyVal) return;

      var q = Math.max(0, parseInt(qty, 10) || 0);
      qtyVal.textContent = q;

      if (q === 0) {
        addBtn.classList.remove('hidden');
        qtyBox.classList.add('hidden');
      } else {
        addBtn.classList.add('hidden');
        qtyBox.classList.remove('hidden');
      }
    }

    function syncFromCart() {
      fetchCart()
        .then(function (cart) {
          cards.forEach(function (card) {
            var activeVariantId = card.getAttribute('data-active-variant-id');
            if (!activeVariantId) {
              setCardUIFromQty(card, 0);
              return;
            }
            var q = getQtyInCart(cart, activeVariantId);
            setCardUIFromQty(card, q);
          });

          document.documentElement.dispatchEvent(
            new CustomEvent('is:cart:updated', { detail: { cart: cart } })
          );
        })
        .catch(function (err) {
          console.error('Cart sync failed', err);
        });
    }

    // Tabs click => scroll to section
    if (showTabs && tabs.length) {
      tabs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var targetId = btn.getAttribute('data-scroll-target');
          var mode = btn.getAttribute('data-mode') || '';
          if (!targetId) return;

          var sectionEl = document.getElementById(targetId);
          if (!sectionEl) return;

          setActiveTab(mode);
          scrollToSection(sectionEl);
        });
      });
    }

    // Initialize active tab based on default + existing section
    setActiveTab(currentMode);

    refreshCards();
    syncFromCart();

// Deterministic scroll spy (Uber Eats style)
(function initScrollSpyFallback() {
  if (!showTabs || !sections.length) return;

  function getStickyOffset() {
    var headerOffset = getFixedHeaderOffset();
    var tabsWrapRect = tabsWrap ? tabsWrap.getBoundingClientRect() : null;
    var tabsHeight = tabsWrapRect ? tabsWrapRect.height : 0;
    return headerOffset + tabsHeight;
  }

  function onScroll() {
    var offset = getStickyOffset();
    var referenceLine = offset + 1;

    var activeMode = null;

    // loop from bottom → top
    for (var i = sections.length - 1; i >= 0; i--) {
      var s = sections[i];
      var rect = s.getBoundingClientRect();
      if (rect.top <= referenceLine) {
        activeMode = s.getAttribute('data-mode') || null;
        break;
      }
    }

    // fallback to first section
    if (!activeMode && sections[0]) {
      activeMode = sections[0].getAttribute('data-mode') || null;
    }

    if (activeMode && activeMode !== currentMode) {
      setActiveTab(activeMode);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  // initial sync
  requestAnimationFrame(onScroll);
})();

    // Add / minus / plus → /cart/update.js
    root.addEventListener('click', function (e) {
      var minus = e.target.closest('.js-order-qty-minus');
      var plus = e.target.closest('.js-order-qty-plus');
      var add = e.target.closest('.js-order-add-to-cart');

      if (!minus && !plus && !add) return;

      var card = e.target.closest('.is-order-card');
      if (!card) return;

      var activeVariantId = card.getAttribute('data-active-variant-id');
      if (!activeVariantId || busy) return;

      var qtyVal = $('.is-order-card__qty-value', card);
      if (!qtyVal) return;

      e.preventDefault();

      var currentQty = Math.max(0, parseInt(qtyVal.textContent, 10) || 0);
      var nextQty = currentQty;

      if (add) {
        nextQty = currentQty + qtyStep;
      } else if (plus) {
        nextQty = currentQty + qtyStep;
      } else if (minus) {
        nextQty = Math.max(0, currentQty - qtyStep);
      }

      if (nextQty === currentQty) return;

      busy = true;
      card.classList.add('is-updating');

      updateVariantQty(activeVariantId, nextQty)
        .then(function (cart) {
          var q = getQtyInCart(cart, activeVariantId);
          setCardUIFromQty(card, q);
          document.documentElement.dispatchEvent(
            new CustomEvent('is:cart:updated', { detail: { cart: cart } })
          );
        })
        .catch(function (err) {
          console.error('Cart update failed', err);
        })
        .finally(function () {
          busy = false;
          card.classList.remove('is-updating');
        });
    });

    window.addEventListener('pageshow', function (ev) {
      var entries =
        performance && performance.getEntriesByType
          ? performance.getEntriesByType('navigation')
          : [];
      var nav = entries && entries[0];
      var fromBFCache = ev.persisted || (nav && nav.type === 'back_forward');

      if (fromBFCache) {
        refreshCards();
        syncFromCart();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var grids = document.querySelectorAll('[data-is-order-grid]');
    Array.prototype.forEach.call(grids, initOrderGrid);
  });
})();
